import { makeStyles, shorthands } from "@fluentui/react-components";
import * as React from "react";
const useStyles = makeStyles({
  heroBanner: {
    backgroundColor: "rgba(255, 255, 255, 1)",
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    width: "100%",
    position: "absolute",
  },

  overlapGroupWrapper: {
    backgroundImage:
      "linear-gradient(114deg, #f0eefa 21.81%, #ece6f1 57.83%, #f4eae7 100%)",
    height: "222px",
    width: "100%",
    ...shorthands.overflow("hidden"),

    "@media (max-width: 540px)": {
      height: "180px",
    },
  },

  overlapGroupWrapperAfter: {
    content: "''",
    zIndex: "0",
    position: "absolute",
    bottom: "0",
    left: "0",
    width: "100%",
    height: "25%",
    backgroundImage:
      "linear-gradient(to top, rgba(250, 250, 250, 1) 0%, rgba(255, 255, 255, 0) 100%)",
    "@media (max-width: 540px)": {
      height: "10%",
    },
  },

  overlapGroup: {
    height: "416px",
    position: "relative",
    width: "100%",

    "@media (max-width: 540px)": {
      height: "195px",
    },
  },

  ellipse: {
    backgroundColor: "#c8c3ec",
    filter: "blur(452.5px)",
    height: "235px",
    left: "808px",
    position: "absolute",
    top: "107px",
    transform: "rotate(28.83deg)",
    width: "364px",
    ...shorthands.borderRadius("182.08px/117.66px"),
  },

  imgContainer: {
    width: "100%",
    display: "flex",
    justifyContent: "center",
    "@media (max-width: 1600px)": {
      justifyContent: "flex-end",
    },
  },

  img: {
    height: "270px",
    width: "100%",
    maxWidth: "1440px",
    backgroundImage: `url('/images/backdrop.webp')`,
    backgroundSize: "cover",
    backgroundRepeat: "no-repeat",
    backgroundPositionY: "center",

    "@media (max-width: 1600px)": {
      maxWidth: "600px",
      backgroundImage: `url('/images/backdrop-cropped.webp')`,
    },

    "@media (max-width: 954px) and (min-width: 541px)": {
      maxWidth: "360px",
    },

    "@media (max-width: 540px)": {
      backgroundImage: `url('/images/backdrop-mobile-cropped.webp')`,
      height: "180px",
      maxWidth: "140px",
    },
  },

  rectangle: {
    backgroundImage:
      "radial-gradient(322.33% 156.47% at 5.88% -75.95%, rgba(255, 193, 158, 0.5) 0%, rgba(255, 255, 255, 0) 100%), linear-gradient(182deg, rgba(227, 223, 240, 0) 46.88%, #fafafa 74.22%)",
    height: "341px",
    left: "0",
    position: "absolute",
    top: "0",
    width: "100%",

    "@media (max-width: 540px)": {
      height: "195px",
      backgroundImage:
        "radial-gradient(322.33% 156.47% at 5.88% -75.95%, rgba(255, 193, 158, 0.5) 0%, rgba(255, 255, 255, 0) 100%), linear-gradient(182deg, rgba(227, 223, 240, 0) 61.44%, #fafafa 92.42%)",
    },
  },
});

export const Backdrop: React.FC = () => {
  const styles = useStyles();
  return (
    <div className={styles.heroBanner}>
      <div className={styles.overlapGroupWrapper}>
        <div className={styles.overlapGroup}>
          <div className={styles.ellipse} />
          <div className={styles.imgContainer}>
            <div className={styles.img}></div>
          </div>
          <div className={styles.rectangle} />
        </div>
        <div className={styles.overlapGroupWrapperAfter}></div>
      </div>
    </div>
  );
};
